var _defs, _path, _circle, _path2, _path3, _circle2, _circle3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.34 63.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c2ccff;}.cls-2{fill:#dfe2ed;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.66,39.04h-13.81l10.06-29.21c.14-.41-.08-.85-.48-.99-.41-.14-.85.08-.99.48l-10.14,29.46c-.03.08-.04.17-.04.25H21.08c0-.08-.01-.17-.04-.25L10.89,9.33c-.14-.41-.58-.62-.99-.48-.41.14-.62.58-.48.99l10.06,29.21H5.67c-3.13,0-5.67,2.54-5.67,5.67v9.82c0,3.13,2.54,5.67,5.67,5.67h2.07c-.1.22-.17.47-.17.74v.91c0,.97.8,1.77,1.77,1.77h11.76c.97,0,1.77-.8,1.77-1.77v-.91c0-.26-.06-.51-.17-.74h28.93c-.1.22-.17.47-.17.74v.91c0,.97.8,1.77,1.77,1.77h11.76c.97,0,1.77-.8,1.77-1.77v-.91c0-.26-.06-.51-.17-.74h2.07c3.13,0,5.67-2.54,5.67-5.67v-9.82c0-3.13-2.54-5.67-5.67-5.67Zm4.12,15.5c0,2.27-1.85,4.12-4.12,4.12H5.67c-2.27,0-4.12-1.85-4.12-4.12v-9.82c0-2.27,1.85-4.12,4.12-4.12h62.99c2.27,0,4.12,1.85,4.12,4.12v9.82Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.6,
    cy: 49.9,
    r: 3.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.09,46.9c-1.66,0-3.01,1.35-3.01,3.01s1.35,3.01,3.01,3.01,3.01-1.35,3.01-3.01-1.35-3.01-3.01-3.01Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.73,46.9c-1.66,0-3.01,1.35-3.01,3.01s1.35,3.01,3.01,3.01,3.01-1.35,3.01-3.01-1.35-3.01-3.01-3.01Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 44.44,
    cy: 49.9,
    r: 3.01
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.17,
    cy: 20.09,
    r: 2.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.96,13.3c.15.24.4.37.66.37.14,0,.28-.04.41-.11.37-.22.48-.7.26-1.07-.1-.16-2.46-3.91-7.9-3.91s-8.18,3.7-8.29,3.86c-.25.35-.18.83.17,1.08.34.25.83.18,1.09-.16.1-.13,2.45-3.22,7.04-3.22s6.5,3.04,6.58,3.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.61,8.09c.35.25.83.18,1.09-.16.05-.06,4.82-6.37,13.87-6.37s12.87,6.06,13.03,6.32c.15.24.4.37.66.37.14,0,.28-.04.41-.11.37-.22.48-.7.26-1.07-.18-.29-4.44-7.06-14.35-7.06s-14.91,6.72-15.12,7.01c-.25.35-.18.83.17,1.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.a9f9063a1622d87ade37db540b981d3e.svg";
export { ForwardRef as ReactComponent };